<template>
  <div class="container">
    <template v-if="!isFetched">
      <div class="page-loader-wrapper" style="position: absolute; transform: translate(-50%, -50%); left: 50%; top: 50%">
        <b-spinner></b-spinner>
      </div>
    </template>
    <template v-else-if="isFetched">
      <h1 class="text-left">Hallo {{ profile.vendor }}</h1>
      <b-card-group deck>
        <b-card
            cols="12" md="6" lg="4"
            title="Produkte"
            style="min-width: 50%"
        >
          <b-card-text>Neue Produkte erstellen oder vorhandene Produkte bearbeiten und verwalten.</b-card-text>
          <b-button to="add_product" variant="secondary" class="mr-2">Hinzufügen</b-button>
          <b-button to="/products" variant="secondary">Produktliste</b-button>
        </b-card>
        <b-card
            style="min-width: 50%"
            cols="12" md="6" lg="4"
            title="Profil"
        >
          <b-card-text>Informationen und Einstellungen zur Lieferung, Zahlung und ihrem Unternehmen.</b-card-text>
          <b-button to="/profile" variant="secondary">Profil bearbeiten</b-button>
        </b-card>
        <b-card
            cols="12" md="6" lg="4"
            title="Dokumente"
        >
          <b-card-text>Eine Übersicht zu allen Dokumenten wie Bestellungen und Rechnungen.</b-card-text>
          <b-button to="/documents" variant="secondary">Dokumente</b-button>
        </b-card>
      </b-card-group>
    </template>
  </div>
</template>
<script>
    import {mapState} from "vuex";
    export default {
        name: 'Home',
        watch: {
            profile(n) {
                if (!n.vendor) {
                    this.$router.push('/profile')
                }
            }
        },
        computed: {
            ...mapState({
                profile: state => state.user.profile,
                isFetched: state => state.user.isFetched,
            }),
        },
        mounted() {
            if (this.isFetched && this.profile && !this.profile.vendor) {
                this.$router.push('/profile')
            }
        }
    }
</script>
